import axios from 'axios';
import { ApiResponse, ErrorResponse, ResponseData } from './models';

const api = axios.create({
  baseURL: `${process.env.REACT_APP_API_URL}`
});

export const getData = async <T>(url: string): Promise<ResponseData<T>> => {
  try {
    const response = await api.get<ApiResponse<T>>(url);
    return { success: true, data: response.data.responseData, errors: [] };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  } catch (error: any) {
    return {
      success: false,
      errors: error.response?.data?.errors?.map(
        (p: ErrorResponse) => p.message
      ) ?? ['Unexpected error']
    };
  }
};
export default api;
